"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');



























const createAndJoinOrgActions = _utils.createAsyncActions('CreateAndJoinOrg')
const requestJoinOrgActions = _utils.createAsyncActions('RequestJoinOrg')
const resendOrgUserInviteActions = _utils.createAsyncActions('ResendOrgUserInvite')
const changeUserOrgTitleActions = _utils.createAsyncActions('ChangeUserOrgTitle')
const updateOrgMemberActions = _utils.createAsyncActions('UpdateOrgMember')
const changeUserOrgRoleActions = _utils.createAsyncActions('ChangeUserOrgRole')
const updateOrgInfoActions = _utils.createAsyncActions('UpdateOrgInfo')
const updateOrgMFASettingsActions = _utils.createAsyncActions('UpdateOrgMFASettings')
const updateOrgPatientAppSettingsActions =
  _utils.createAsyncActions('UpdateOrgPatientAppSettings')
const getOrgSMSStopLineActions = _utils.createAsyncActions('GetOrgSMSStopLine')
const updateOrgSMSStopLineActions = _utils.createAsyncActions('UpdateOrgSMSStopLine')
const getOrgPatientPhoneSettingsActions =
  _utils.createAsyncActions('GetOrgPatientPhoneSettings')
const updateOrgPatientPhoneSettingsActions =
  _utils.createAsyncActions('UpdateOrgPatientPhoneSettings')
const cancelJoinOrgRequestActions = _utils.createAsyncActions('CancelJoinOrgRequest')
const approvePendingUserActions = _utils.createAsyncActions('ApprovePendingUser')
const rejectPendingUserActions = _utils.createAsyncActions('RejectPendingUser')
const removeUserFromOrgActions = _utils.createAsyncActions('RemoveUserFromOrg')
const leaveOrgActions = _utils.createAsyncActions('LeaveOrg')
const createOrgWithNewAdminActions = _utils.createAsyncActions('CreateOrgWithNewAdmin')
const addUsersToOrgActions = _utils.createAsyncActions('AddUsersToOrg')
const listAPIKeysActions = _utils.createAsyncActions('ListAPIKeys')
const revokeAPIKeyActions = _utils.createAsyncActions('RevokeAPIKey')
const setAPIKeyExpiryActions = _utils.createAsyncActions('SetAPIKeyExpiry')

 const actionCreators = {
  createAndJoinOrgActions,
  requestJoinOrgActions,
  resendOrgUserInviteActions,
  changeUserOrgTitleActions,
  updateOrgMemberActions,
  changeUserOrgRoleActions,
  updateOrgInfoActions,
  updateOrgMFASettingsActions,
  updateOrgPatientAppSettingsActions,
  getOrgSMSStopLineActions,
  updateOrgSMSStopLineActions,
  getOrgPatientPhoneSettingsActions,
  updateOrgPatientPhoneSettingsActions,
  cancelJoinOrgRequestActions,
  approvePendingUserActions,
  rejectPendingUserActions,
  removeUserFromOrgActions,
  leaveOrgActions,
  createOrgWithNewAdminActions,
  addUsersToOrgActions,
  listAPIKeysActions,
  revokeAPIKeyActions,
  setAPIKeyExpiryActions,
}; exports.actionCreators = actionCreators

const createAndJoinOrg = (req) =>
  _helpers.wsCommand('CreateAndJoinOrg', createAndJoinOrgActions, req, null)

const requestJoinOrg = (req) =>
  _helpers.wsCommand('RequestJoinOrg', requestJoinOrgActions, req, null)

const resendOrgUserInvite = (req) =>
  _helpers.wsCommand('ResendOrgUserInvite', resendOrgUserInviteActions, req, null)

const changeUserOrgTitle = (req) =>
  _helpers.wsCommand('ChangeUserOrgTitle', changeUserOrgTitleActions, req, null)

const updateOrgMember = (req) =>
  _helpers.wsCommand('UpdateOrgMember', updateOrgMemberActions, req, null)

const changeUserOrgRole = (req) =>
  _helpers.wsCommand('ChangeUserOrgRole', changeUserOrgRoleActions, req, null)

const updateOrgInfo = (req) =>
  _helpers.wsCommand('UpdateOrgInfo', updateOrgInfoActions, req, null)

const updateOrgMFASettings = (req) =>
  _helpers.wsCommand('UpdateOrgMFASettings', updateOrgMFASettingsActions, req, null)

// Admin-only: don't call it for a user who isn't an admin of the org.
const updateOrgPatientAppSettings = (req) =>
  _helpers.wsCommand('UpdateOrgPatientAppSettings', updateOrgPatientAppSettingsActions, req, null)

const getOrgSMSStopLine = (req) =>
  _helpers.wsCommand('GetOrgSMSStopLine', getOrgSMSStopLineActions, req, null)

const updateOrgSMSStopLine = (req) =>
  _helpers.wsCommand('UpdateOrgSMSStopLine', updateOrgSMSStopLineActions, req, null)
// Admin-only: don't call these for a user who isn't an admin of the org.
const getOrgPatientPhoneSettings = (req) =>
  _helpers.wsCommand(
    'GetOrgPatientPhoneSettings',
    getOrgPatientPhoneSettingsActions,
    req,
    null,
  )

const updateOrgPatientPhoneSettings = (req) =>
  _helpers.wsCommand(
    'UpdateOrgPatientPhoneSettings',
    updateOrgPatientPhoneSettingsActions,
    req,
    null,
  )

const cancelJoinOrgRequest = (req) =>
  _helpers.wsCommand('CancelJoinOrgRequest', cancelJoinOrgRequestActions, req, null)

const approvePendingUser = (req) =>
  _helpers.wsCommand('ApprovePendingUser', approvePendingUserActions, req, null)

const rejectPendingUser = (req) =>
  _helpers.wsCommand('RejectPendingUser', rejectPendingUserActions, req, null)

const removeUserFromOrg = (req) =>
  _helpers.wsCommand('RemoveUserFromOrg', removeUserFromOrgActions, req, null)

const leaveOrg = (req) =>
  _helpers.wsCommand('LeaveOrg', leaveOrgActions, req, null)

const createOrgWithNewAdmin = (req) =>
  _helpers.wsCommand(
    'CreateOrgWithNewAdmin',
    createOrgWithNewAdminActions,
    req,
    null,
  )

const addUsersToOrg = async (req) =>
  req.UserKeys.length
    ? _helpers.wsCommand('AddUsersToOrg', addUsersToOrgActions, req, null)
    : { Users: {}, Orgs: {} }

const listAPIKeys = (req) =>
  _helpers.wsCommand('ListAPIKeys', listAPIKeysActions, req, null)

const revokeAPIKey = (req) =>
  _helpers.wsCommand('RevokeAPIKey', revokeAPIKeyActions, req, null)

const setAPIKeyExpiry = (req) =>
  _helpers.wsCommand('SetAPIKeyExpiry', setAPIKeyExpiryActions, req, null)

exports. default = {
  createAndJoinOrg,
  requestJoinOrg,
  resendOrgUserInvite,
  changeUserOrgTitle,
  updateOrgMember,
  changeUserOrgRole,
  updateOrgInfo,
  updateOrgMFASettings,
  updateOrgPatientAppSettings,
  getOrgSMSStopLine,
  updateOrgSMSStopLine,
  getOrgPatientPhoneSettings,
  updateOrgPatientPhoneSettings,
  cancelJoinOrgRequest,
  approvePendingUser,
  rejectPendingUser,
  removeUserFromOrg,
  leaveOrg,
  createOrgWithNewAdmin,
  addUsersToOrg,
  listAPIKeys,
  revokeAPIKey,
  setAPIKeyExpiry,
}
